import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearPath, setRetrunToPrevPath, selectPath, selectReturnToPrevPath } from "./pathSlice";

const Path = () => {
    const dispatch = useDispatch();
    const path = useSelector(selectPath);
    const isReturned = useSelector(selectReturnToPrevPath);
    const navigate = useNavigate();

    useEffect(() => {
        if(!path) {
            return
        }
        navigate(path)
        dispatch(clearPath())
    }, [dispatch, navigate, path]);

    useEffect(() => {
        if(isReturned) {
            navigate(path)
            dispatch(setRetrunToPrevPath({
                returnToPrevPath: false
            }))
        }

    }, [dispatch, isReturned, navigate, path])

    return <></>;
};

export default Path;
